/* second interactive layer: alternating left/right scroll-in reveals */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = ['.mini-features > div', '.badgebar .badge', '.le-row', '.wsb-stat', '.g-card',
    '.ps-grid figure', '.review', '.compare-cards .cc', '.use-step', '.trust-row span'];
  var els = [];
  sel.forEach(function (q) {
    document.querySelectorAll(q).forEach(function (el, i) {
      el.classList.add(i % 2 === 0 ? 'psm-left' : 'psm-right');
      els.push(el);
    });
  });
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var el = e.target;
        var siblings = Array.prototype.slice.call(el.parentElement.children).filter(function (c) {
          return c.classList.contains('psm-left') || c.classList.contains('psm-right');
        });
        var idx = siblings.indexOf(el);
        setTimeout(function () { el.classList.add('psm-in'); }, Math.max(0, idx) * 90);
        io.unobserve(el);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
